"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardAlerts = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var dataLoaders_1 = require("../../dataLoaders");
var utils_1 = require("./utils");
/**
 * Hook allowing to download dashboard alerts data for the current user
 * @param config - configuration of the hook
 * @beta
 * @deprecated Will be removed in the 8.10.0 release. Superseded by Dashboard component; please see `@gooddata/sdk-ui-dashboard` and GoodData.UI documentation for v8.7
 */
function useDashboardAlerts(_a) {
    var dashboard = _a.dashboard, backend = _a.backend, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess, workspace = _a.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useDashboardAlerts");
    utils_1.workspaceInvariant(effectiveWorkspace, "useDashboardAlerts");
    var loader = dataLoaders_1.dashboardAlertsDataLoaderFactory.forWorkspace(effectiveWorkspace);
    var promise = function () { return loader.getDashboardAlerts(effectiveBackend, dashboard); };
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        sdk_model_1.objRefToString(dashboard),
    ]);
}
exports.useDashboardAlerts = useDashboardAlerts;
//# sourceMappingURL=useDashboardAlerts.js.map